import { StoriesRepository } from '../repositories/stories.repository'
import {
    StoriesCreateStoryResponseT,
    StoriesCreateStorySlideResponseT,
    StoriesGetListResponseT,
    StoriesGetStoryResponseT,
    StoriesGetStorySlidesResponseT,
    StoryPayloadT,
} from '../types/stories.types'

const storiesRepository = new StoriesRepository()

export class StoriesService {
    async getList(page: number): Promise<StoriesGetListResponseT> {
        const response = await storiesRepository.getList(page)
        return response.data
    }

    async getStory(story_id: number): Promise<StoriesGetStoryResponseT> {
        const response = await storiesRepository.getStory(story_id)
        return response.data
    }

    async createStory(payload: StoryPayloadT): Promise<StoriesCreateStoryResponseT> {
        const response = await storiesRepository.createStory(payload)
        return response.data
    }

    async updateStory(
        story_id: number,
        payload: StoryPayloadT
    ): Promise<StoriesCreateStoryResponseT> {
        const response = await storiesRepository.updateStory(story_id, payload)
        return response.data
    }

    async publishStory(story_id: number): Promise<void> {
        const response = await storiesRepository.publishStory(story_id)
        return response.data
    }

    async unpublishStory(story_id: number): Promise<void> {
        const response = await storiesRepository.unpublishStory(story_id)
        return response.data
    }

    async deleteStory(story_id: number): Promise<void> {
        const response = await storiesRepository.deleteStory(story_id)
        return response.data
    }

    async getStorySlides(story_id: number): Promise<StoriesGetStorySlidesResponseT> {
        const response = await storiesRepository.getStorySlides(story_id)
        return response.data
    }

    async createStorySlide(
        story_id: number,
        payload: FormData
    ): Promise<StoriesCreateStorySlideResponseT> {
        const response = await storiesRepository.createStorySlide(story_id, payload)
        return response.data
    }

    async updateStorySlide(
        story_id: number,
        payload: FormData
    ): Promise<StoriesCreateStorySlideResponseT> {
        const response = await storiesRepository.updateStorySlide(story_id, payload)
        return response.data
    }

    async deleteStorySlide(slide_id: number): Promise<void> {
        const response = await storiesRepository.deleteStorySlide(slide_id)
        return response.data
    }
}
